class LetoileAccountMenus {
  constructor(root = document) {
    this.menus = [...new Set(root.querySelectorAll('[data-account-menu], [data-shell-menu]'))];
    if (!this.menus.length) return;

    this.menus.forEach((menu) => {
      menu.addEventListener('toggle', () => {
        if (!menu.open) return;
        this.menus.forEach((otherMenu) => {
          if (otherMenu !== menu) otherMenu.removeAttribute('open');
        });
      });
    });

    document.addEventListener('pointerdown', (event) => {
      this.menus.forEach((menu) => {
        if (menu.open && !menu.contains(event.target)) menu.removeAttribute('open');
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const openMenu = this.menus.find((menu) => menu.open);
      if (!openMenu) return;
      openMenu.removeAttribute('open');
      openMenu.querySelector('summary')?.focus();
    });
  }
}

new LetoileAccountMenus();
